/**
 * Przeniesienie koszyka zagranicznego na wersje angielska.
 *
 * Ceny wysylki dla stref zagranicznych sa wpisane wylacznie w polach EUR, a WCML
 * wiaze walute z jezykiem (pl -> PLN, en/de -> EUR). Klient ogladajacy polska
 * wersje z adresem np. na Slowacji nie zobaczy zadnej sensownej metody wysylki.
 *
 * Decyzje podejmuje serwer: szablon woocommerce/cart/cart-shipping.php wypisuje
 * znacznik .ecotex-foreign-redirect[data-url], gdy trzeba przeniesc klienta.
 * Ten szablon przeladowuje sie razem z sekcja wysylki przy kazdej zmianie kraju,
 * wiec nie musimy zgadywac, ktore pole formularza jest aktualne ani walczyc
 * z Select2, ktory emituje zdarzenia przez jQuery.
 */

const MARKER = '.ecotex-foreign-redirect[data-url]';

function maybeRedirect() {
    const marker = document.querySelector(MARKER);

    if (!marker) {
        return;
    }

    const url = marker.getAttribute('data-url');

    if (!url) {
        return;
    }

    // Nie zapetlaj sie, jesli juz tu jestesmy.
    if (url === window.location.href || url === window.location.href.split('#')[0]) {
        return;
    }

    window.location.href = url;
}

function init() {
    if (!document.querySelector('form.woocommerce-checkout, .woocommerce-cart-form, .cart_totals')) {
        return;
    }

    maybeRedirect();

    if (!window.jQuery) {
        return;
    }

    // Kazde z tych zdarzen leci po przeladowaniu sekcji wysylki przez WooCommerce.
    window.jQuery(document.body).on(
        'updated_checkout updated_shipping_method updated_cart_totals updated_wc_div',
        maybeRedirect
    );
}

export default { init };
